import { ShadowController, SHADOW_DEFAULTS } from './ShadowController.js';
import { IVector3 } from '../../../../api.js';
export class DirectionalLightShadowController extends ShadowController {
    constructor(_light, _babylon_light, _light_system) {
        const shadow_values = SHADOW_DEFAULTS.DIRECTIONAL_LIGHT;
        super(_light, _babylon_light, _light_system, shadow_values.resolution, shadow_values.near, shadow_values.far, _babylon_light.getEngine().webGLVersion === 1 ? shadow_values.webgl1_bias : shadow_values.webgl2_bias);
    }
    should_update_shadowmap(meshes_modifications) {
        // TODO rework to `some`? compare performance
        for (const mod of meshes_modifications) {
            // Checks if the moved object was or is in the bounds of the shadow.
            const light_affects_old_bounds = this.sphere_inside_dirlight_shadow(mod.old_bounds, this._light);
            const light_affects_new_bounds = this.sphere_inside_dirlight_shadow(mod.new_bounds, this._light);
            if (light_affects_old_bounds || light_affects_new_bounds) {
                return true;
            }
        }
        return false;
    }
    sphere_inside_dirlight_shadow(sphere, light) {
        // Right now the directional light frustum is automatically adjusted to contain all shadowcasters
        // which makes this check kind of useless. But we can still avoid drawing the shadowmap when
        // we move stuff outside the near and far plane.
        const offset = IVector3.subtract(sphere.position, light.position);
        const z = IVector3.dot(offset, light.get_direction());
        return (z - sphere.radius) < this.shadow_far && (z + sphere.radius) > this.shadow_near;
    }
}
//# sourceMappingURL=DirectionalLightShadowController.js.map